<div class="file-export-popup">
  <div class="file-export-popup__modal">
    <button type="button" class="file-export-popup__cross-btn" (click)="close()">
      <app-icon class="file-export-popup__cross-icon" [icon]="IconName.CROSS" />
    </button>
    <app-icon class="file-export-popup__loader-icon" [icon]="IconName.LOADER" />
    <p class="file-export-popup__text-message">
      {{ 'inventory.uploadComponent.title' | translate }}
    </p>
  </div>
</div>
